import DataFormSubmitPage from 'app/pages/DataFormSubmit';
import React from 'react';

const HectoPayment = () => {
  return <DataFormSubmitPage />;
};

export default HectoPayment;
